import React from 'react';
import ContentLoader from 'react-content-loader'
import settings from '../../../settings.json'

function CategoryPs(props) {
    return (
        <>
            <div style={{borderTop:"1px solid #F5F5F5", borderRight:"1px solid #F5F5F5",padding:"5px"}} className="d-none d-md-block">
            <ContentLoader
                height={140}
                speed={settings.placehoder.speed}
                style={{width:"100%"}}
                backgroundColor={settings.placehoder.background}
                foregroundColor={settings.placehoder.foreground}
            >
                <rect x="0" y="10" rx="0" ry="0" height="15" style={{width:"100%"}} />
                <rect x="0" y="35" rx="0" ry="0" height="15" style={{width:"100%"}} />
                <rect x="0" y="60" rx="0" ry="0" height="15" style={{width:"100%"}} />
            </ContentLoader>
            </div>
            <div className="d-block d-md-none">
                <ContentLoader
                    height={50}
                    speed={settings.placehoder.speed}
                    style={{width:"100%"}}
                    backgroundColor={settings.placehoder.background}
                    foregroundColor={settings.placehoder.foreground}
                >
                    <rect x="0" y="10" rx="0" ry="0" height="30" style={{width:"50%"}} />
                </ContentLoader>
            </div>
        </>
    );
}

export default CategoryPs;